import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'avs-digital-ionaming-dialog',
  standalone: false,
  templateUrl: './digital-ionaming-dialog.component.html',
  styleUrl: './digital-ionaming-dialog.component.css'
})
export class DigitalIONamingDialogComponent {

  public digitalInput1: string = '';
  public digitalInput2: string = '';
  public digitalInput3: string = '';
  public digitalInput4: string = '';

  public digitalOutput1: string = '';
  // public digitalOutput2: string = '';

  public isDigitalInput1Selected: boolean = true;
  public isDigitalInput2Selected: boolean = true;
  public isDigitalInput3Selected: boolean = true;
  public isDigitalInput4Selected: boolean = true;

  public isDigitalOutput1Selected: boolean = true;
  constructor(
    private dialogRef: MatDialogRef<DigitalIONamingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }


  public onNoClick(): void {
    this.dialogRef.close();
  }

  public onYesClick(): void {

    const entries: string[] = [];
    if (this.isDigitalInput1Selected) {
      entries.push(`"1": "${this.digitalInput1}"`);
    }
    if (this.isDigitalInput2Selected) {
      entries.push(`"2": "${this.digitalInput2}"`);
    }
    if (this.isDigitalInput3Selected) {
      entries.push(`"3": "${this.digitalInput3}"`);
    }
    if (this.isDigitalInput4Selected) {
      entries.push(`"4": "${this.digitalInput4}"`);
    }
    if (this.isDigitalOutput1Selected) {
      entries.push(`"7": "${this.digitalOutput1}"`);
    }
    const finalContent = `{${entries.join(",")}}`;

    this.dialogRef.close(finalContent);
  }
}
